import { count_occurences } from './helpers';

export default function template_parser(template, placeholder, parse) {
	if (typeof placeholder === 'function') {
		parse = placeholder;
		placeholder = 'x';
	}

	var max_characters = count_occurences(placeholder, template);

	return function parse_character(character, value) {
		if (value.length >= max_characters) {
			return;
		}

		return parse(character, value);
	};
}
//# sourceMappingURL=template parser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/input-format/es6/template parser.js
// module id = 410
// module chunks = 0